export default __webpack_public_path__ + "static/media/image-24.19a02030.png";